import { Box, Container, Grid, Typography } from '@mui/material';
import { SettingsOverscan } from '@mui/icons-material';
import QuestionsTextAreaArena251 from '../QuestionsLiveArena251';

const questions = [{ title: 'Pergunta 1' }, { title: 'Pergunta 2' }, { title: 'Pergunta 3' }];

export default function VideoSectionLiveRevalida251() {
	return (
		<Container
			fixed
			maxWidth="md"
			disableGutters={true}
			className={'revalida'}
		>
			<Grid
				container
				className={'section'}
				sx={{
					justifyContent: 'center',
					alignItems: 'center',
					marginBottom: 0,
				}}
			>
				<Box
					sx={{
						paddingY: 2,
					}}
				>
					<Typography
						variant={'h4'}
						fontFamily={'Poppins'}
						fontSize={{ xs: '12px', md: '16px' }}
						color={'#CCCCCC'}
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							gap: 0.5,
						}}
					>
						{'Dica: clique no'}{' '}
						<SettingsOverscan sx={{ width: { xs: 14, md: 16 }, height: { xs: 14, md: 16 } }} />{' '}
						{'do player para assistir em tela cheia'}
					</Typography>
				</Box>
				<Grid
					container
					xs={12}
					sx={{
						position: 'relative',
						width: '100%',
						height: 0,
						paddingBottom: '56%',
						justifyContent: 'center',
						alignItems: 'center',
						borderRadius: { xs: '16px', md: '24px' },
						overflow: 'hidden',
					}}
				>
					<iframe
						src="https://www.youtube.com/embed/okb4sWzo7xM?si=P1OVuwlYGxpCh3UH"
						title="YouTube video player"
						frameborder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
						referrerpolicy="strict-origin-when-cross-origin"
						allowfullscreen={true}
						style={{
							position: 'absolute',
							width: '100%',
							height: '100%',
							left: 0,
							top: 0,
						}}
					></iframe>
				</Grid>
			</Grid>
			<Box
				className={'section'}
				sx={{
					paddingY: 4,
				}}
			>
				<Typography
					variant={'h4'}
					fontFamily={'Poppins'}
					fontSize={'20px'}
					fontWeight={500}
					color={'#FFFFFF'}
				>
					Desafio dos Imbatíveis
				</Typography>
				<Typography
					variant={'h4'}
					fontFamily={'Poppins'}
					fontSize={'16px'}
					fontWeight={400}
					lineHeight={1.2}
					color={'#9E9E9E'}
				>
					Responda as questões abaixo apenas quando solicitado na live.{' '}
				</Typography>
				<Box>
					{questions?.map((q) => (
						<QuestionsTextAreaArena251 title={q?.title} />
					))}
				</Box>
			</Box>
		</Container>
	);
}
